import { Box } from '@mantine/core'

import { TruncatedText } from './TruncatedText.tsx'

export interface UserDisplayData {
  display: string
  name: string
  email: string
}

export interface UserDisplayProps {
  user: UserDisplayData
  showDetailedView?: boolean
}

/**
 * Component for displaying user information with conditional detailed view.
 * Shows name and email on separate lines when showDetailedView is true and both values exist,
 * otherwise falls back to the display value.
 */
export function UserDisplay({ user, showDetailedView = false }: UserDisplayProps) {
  const shouldShowDetailed = showDetailedView && user.name && user.email

  if (shouldShowDetailed) {
    return (
      <Box style={{ maxWidth: '100%', overflow: 'hidden', lineHeight: 1.3 }} role="group" aria-label="User details">
        <TruncatedText size="sm" fw={500} aria-label={`Name: ${user.name}`}>
          {user.name}
        </TruncatedText>
        <TruncatedText size="sm" fw={500} c="dimmed" aria-label={`Email: ${user.email}`}>
          {user.email}
        </TruncatedText>
      </Box>
    )
  }

  return (
    <TruncatedText style={{ maxWidth: '100%' }} aria-label={`User: ${user.display}`}>
      {user.display}
    </TruncatedText>
  )
}
